import { XYPosition } from '@xyflow/react';
import { GroupBoundingBox } from '../canvas-types/nodeTypesData';
import { PADDING_WIDTH } from '../nodes/helpers';

const GROUP_LABEL_Y_OFFSET = 30;

export const calculateGroupLabelPosition = (
  groupPosition: XYPosition,
  groupBoundingBox: GroupBoundingBox,
): XYPosition => {
  return {
    x: groupPosition.x + groupBoundingBox.marginLeft + PADDING_WIDTH,
    y: groupPosition.y + groupBoundingBox.marginTop + GROUP_LABEL_Y_OFFSET,
  };
};
